export default "__VITE_ASSET__5J8IHfGo__"